import request from '../_util/request';
import { computed, defineComponent, ref, watch } from 'vue';
import { default as PfSelect, selectProps } from '../select';
import { default as PfTreeSelect, treeSelectProps } from '../tree-select';
import omit from '../_util/omit';
import { withInstall } from '../_util/type';
import { pinyin } from 'pinyin-pro';
var StructureTypeEnum;
(function (StructureTypeEnum) {
    StructureTypeEnum["List"] = "2008-01";
    StructureTypeEnum["Tree"] = "2008-02";
})(StructureTypeEnum || (StructureTypeEnum = {}));
const getCofig = (params) => request('/develop/module/sink/render.open', {
    params
});
const _selectProps = {
    ...omit(selectProps(), [
        'options'
    ]),
};
const _treeSelectProps = {
    ...omit(treeSelectProps(), [
        'treeData'
    ]),
};
export const selectProProps = () => ({
    ..._treeSelectProps,
    ..._selectProps,
    treeDefaultExpandAll: {
        type: Boolean,
        default: true
    },
    value: [Array, Object, String, Number],
    showSearch: {
        type: Boolean,
        default: true
    },
    defaultValue: [Array, Object, String, Number],
    code: String,
    hisUuid: String,
    domain: String,
    config: Object,
    surname: Boolean,
    onConfigChange: Function,
    'onUpdate:configValue': Function,
});
const selectSlots = [
    'notFoundContent',
    'suffixIcon',
    'itemIcon',
    'removeIcon',
    'clearIcon',
    'dropdownRender',
    'option',
    'placeholder',
    'tagRender',
    'maxTagPlaceholder',
    'optionLabel', // donot use, maybe remove it
];
const treeSelectSlots = [
    'title',
    'titleRender',
    'placeholder',
    'maxTagPlaceholder',
    'treeIcon',
    'switcherIcon',
    'notFoundContent',
];
const SelectPro = defineComponent({
    name: 'PfSelectPro',
    inheritAttrs: false,
    props: selectProProps(),
    slots: [...new Set(...selectSlots, ...treeSelectSlots)],
    setup(props, { attrs, slots, emit }) {
        const configLoading = ref(false);
        const config = ref();
        const selectMergedProps = computed(() => {
            let res = {};
            Object.keys(_selectProps).forEach(key => {
                if (props.hasOwnProperty(key) && props[key] !== undefined) {
                    res[key] = props[key];
                }
            });
            return res;
        });
        const treeSelectMergedProps = computed(() => {
            let res = {};
            Object.keys(_treeSelectProps).forEach(key => {
                if (props.hasOwnProperty(key) && props[key] !== undefined) {
                    res[key] = props[key];
                }
            });
            return res;
        });
        const handleConfig = (value) => {
            config.value = value;
            props.onConfigChange?.(value);
            emit('update:configValue', value);
        };
        watch([
            () => props.code,
            () => props.hisUuid,
            () => props.domain,
            () => props.config
        ], ([curCode, curHisUuid, curDomain, curConfig], [preCode, preHisUuid, preDomain, preConfig]) => {
            if ((curCode && curCode !== preCode) || (curHisUuid && curHisUuid !== preHisUuid) || ((curCode || curHisUuid) && curDomain !== preDomain)) {
                configLoading.value = true;
                getCofig({
                    moduleCode: curCode || '',
                    hisUuid: curHisUuid && !curCode ? curHisUuid : ''
                }).then(res => {
                    handleConfig(res);
                }).finally(() => {
                    configLoading.value = false;
                });
            }
            else if (curConfig && (curConfig !== preConfig)) {
                Promise.resolve().then(() => {
                    handleConfig(curConfig);
                });
            }
        }, {
            immediate: true
        });
        const filterInput = (inputValue, label) => {
            if (label?.includes(inputValue)) {
                return true;
            }
            else {
                const zhInitials = pinyin(label, {
                    pattern: 'first',
                    toneType: 'none',
                    separator: '',
                    // removeNonZh: true,
                    mode: props.surname ? 'surname' : 'normal'
                });
                return zhInitials?.includes(inputValue);
            }
        };
        const filterSelect = (inputValue, option) => {
            if (inputValue) {
                const { label } = option || {};
                return filterInput(inputValue, label);
            }
            else {
                return true;
            }
        };
        const renderSelect = () => (<PfSelect placeholder="请选择" filterOption={filterSelect} {...attrs} {...selectMergedProps.value} options={config.value?.datas} v-slots={{ ...slots }}/>);
        const filterTreeSelect = (inputValue, node) => {
            if (inputValue) {
                const { label } = node || {};
                return filterInput(inputValue, label);
            }
            else {
                return true;
            }
        };
        const renderTreeSelect = () => (<PfTreeSelect placeholder="请选择" filterTreeNode={filterTreeSelect} {...attrs} {...treeSelectMergedProps.value} treeData={config.value?.datas} v-slots={{ ...slots }}/>);
        return () => {
            if (config.value?.frameType === StructureTypeEnum.List) {
                return renderSelect();
            }
            else if (config.value?.frameType === StructureTypeEnum.Tree) {
                return renderTreeSelect();
            }
            else {
                return null;
            }
        };
    }
});
export default withInstall(SelectPro);
